const focussableElements = 'a:not([disabled]), button:not([disabled]), input:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
/**
 * Sposta il focus sull'elemento o sul prossimo.
 */
const focusNextElement = (fromElement) => {
    if (document.activeElement) {
        const focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements), (element) => element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement);
        const index = focussable.indexOf(document.activeElement);
        setTimeout(() => {
            const nextElement = focussable[index + 1];
            if (document.activeElement === fromElement && nextElement) {
                nextElement.focus();
            }
        }, 0);
    }
};
var nodeHelpers = {
    focusNextElement,
};

export { nodeHelpers as default };
